import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/logos.png'
import _imports_1 from '../../assets/slice-right.png'


const _hoisted_1 = {
  class: "main",
  style: {"font-size":"16px !important"}
}
const _hoisted_2 = { class: "ub-card" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { style: {"float":"right"} }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "ub-card" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "ub-from" }
const _hoisted_9 = { class: "ub-from-row-3" }
const _hoisted_10 = { class: "ub-col" }
const _hoisted_11 = { class: "ub-label-item" }
const _hoisted_12 = { class: "ub-col" }
const _hoisted_13 = { class: "ub-label-item" }
const _hoisted_14 = { class: "ub-col" }
const _hoisted_15 = { class: "ub-label-item" }
const _hoisted_16 = { class: "ub-col" }
const _hoisted_17 = { class: "ub-label-item" }
const _hoisted_18 = { class: "ub-col" }
const _hoisted_19 = { class: "ub-label-item" }
const _hoisted_20 = { class: "ub-card" }
const _hoisted_21 = { class: "title" }
const _hoisted_22 = {
  key: 0,
  style: {"float":"right"}
}
const _hoisted_23 = { class: "content" }
const _hoisted_24 = { class: "ub-from" }
const _hoisted_25 = { class: "ub-col" }
const _hoisted_26 = { class: "ub-label-item" }
const _hoisted_27 = { style: {"float":"right","margin-top":"10px"} }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { style: {"margin":"0 10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form_item = _resolveComponent("a-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "tit_logo" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        class: "logo"
      }),
      _createElementVNode("span", null, "校外车辆入校预约（因私）申请")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("span", null, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: ""
          }),
          _createTextVNode(" 车辆信息 ")
        ], -1)),
        _createElementVNode("span", _hoisted_4, "申请时间： " + _toDisplayString(_ctx.dataState.applyInfo.createTime), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_table, {
          dataSource: _ctx.dataState.dataList,
          columns: _ctx.dataState.columns,
          pagination: false
        }, null, 8, ["dataSource", "columns"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "title" }, [
        _createElementVNode("span", null, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: ""
          }),
          _createTextVNode(" 被访人信息 ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "ub-label-title ub-text" }, "被访人姓名:", -1)),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataState.applyInfo.beAccessName) = $event)),
                      class: "ub-input",
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _ctx.dataState.applyInfo.beAccessName]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "ub-label-title ub-text" }, "人员编号:", -1)),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataState.applyInfo.beAccessGh) = $event)),
                      class: "ub-input",
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _ctx.dataState.applyInfo.beAccessGh]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "ub-label-title ub-text" }, "到访校区:", -1)),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataState.applyInfo.visiCampus) = $event)),
                      class: "ub-input",
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _ctx.dataState.applyInfo.visiCampus]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "ub-label-title ub-text" }, "到访日期:", -1)),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataState.applyInfo.visiStartTime) = $event)),
                      class: "ub-input",
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _ctx.dataState.applyInfo.visiStartTime]
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "ub-label-title ub-text" }, "到访事由:", -1)),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("textarea", {
                    type: "text",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataState.applyInfo.reason) = $event)),
                    class: "ub-text-area",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _ctx.dataState.applyInfo.reason]
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _cache[14] || (_cache[14] = _createElementVNode("span", null, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: ""
          }),
          _createTextVNode(" 被访人审批 ")
        ], -1)),
        (!_ctx.dataState.view)
          ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
              _createElementVNode("button", {
                class: "ub-btn-ty",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dataState.submit(1)))
              }, "同意"),
              _createElementVNode("button", {
                class: "ub-btn-error",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dataState.submit(2)))
              }, "不同意")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_27, [
                    (_ctx.dataState.view && _ctx.dataState.idea)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, "审核结果：" + _toDisplayString(_ctx.dataState.idea == 1 ? '同意' : '不同意'), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_29, "审核人：" + _toDisplayString(_ctx.dataState.shr), 1),
                    _createElementVNode("span", null, "审核日期：" + _toDisplayString(_ctx.dataState.shdate), 1)
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}